import React from 'react';
import { Form } from 'reactstrap';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import FormFooter from '../../../common/forms/FormFooter';
import DynamicForm from '../../../common/forms/DynamicForm';
import { generateHolidayColumns } from '../../../../config/dynamicFormFields';

const FORM_NAME = 'HolidayListForm';

const selector = formValueSelector(FORM_NAME);

export const HolidayListForm = ({ handleSubmit, onSubmit, holidayList }) => {
  const onHandleSubmit = (formValues) => {
    if (!holidayList.length) {
      toastr.error('Error', 'Ingrese al menos un feriado.');
      return;
    }

    onSubmit(formValues);
  };

  return (
    <Form onSubmit={handleSubmit(onHandleSubmit)}>
      <DynamicForm name="holidayList" columns={generateHolidayColumns()} />
      <FormFooter />
    </Form>
  );
};

HolidayListForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  holidayList: PropTypes.arrayOf(PropTypes.shape({})),
};

HolidayListForm.defaultProps = {
  holidayList: [],
};

const mapStateToProps = (state) => ({
  holidayList: selector(state, 'holidayList'),
});

const formComponent = reduxForm({
  form: FORM_NAME,
  initialValues: { holidayList: [{}] },
})(HolidayListForm);

export default connect(mapStateToProps, null)(formComponent);